"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHalfHoursforDay = exports.isDateInPast = exports.isValidToday = exports.formatFullDate = void 0;
var date_fns_1 = require("date-fns");
var formatFullDate = function (date) {
    return (0, date_fns_1.format)(date, 'do MMMM yyyy');
};
exports.formatFullDate = formatFullDate;
var isValidToday = function (startDate, endDate) {
    if (startDate === void 0) { startDate = (0, date_fns_1.format)(new Date(Date.now()), 'yyyy-MM-dd'); }
    if (endDate === void 0) { endDate = (0, date_fns_1.format)(new Date(Date.now()), 'yyyy-MM-dd'); }
    var today = (0, date_fns_1.format)(new Date(Date.now()), 'yyyy-MM-dd');
    return (((0, date_fns_1.isAfter)(today, startDate) || (0, date_fns_1.isEqual)(today, startDate)) &&
        ((0, date_fns_1.isBefore)(today, endDate) || (0, date_fns_1.isEqual)(today, endDate)));
};
exports.isValidToday = isValidToday;
var isDateInPast = function (date) {
    var today = (0, date_fns_1.format)(new Date(Date.now()), 'yyyy-MM-dd');
    return (0, date_fns_1.isBefore)(date, today);
};
exports.isDateInPast = isDateInPast;
var createHalfHoursforDay = function (currentDay) {
    var start = (0, date_fns_1.startOfDay)(currentDay);
    var hours = (0, date_fns_1.eachHourOfInterval)({
        start: start,
        end: (0, date_fns_1.add)(start, { days: 1 }),
    });
    var halfHours = hours
        .slice(0, hours.length - 1)
        .reduce(function (acc, val) { return __spreadArray(__spreadArray([], __read(acc), false), [val, (0, date_fns_1.add)(val, { minutes: 30 })], false); }, []);
    return halfHours;
};
exports.createHalfHoursforDay = createHalfHoursforDay;
